import styles from './RichList.module.scss';

import clsx from 'clsx';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function RichList(props: Props) {
  const className = clsx(styles['root']);

  return <ul className={className}>{props.children}</ul>;
}
